export const ServiceLookupRoute = {
  SERVICELOOKUPS: 'servicelookups',
};

export const ServiceLookupPathName = {
  SERVICELOOKUPS: 'servicelookups',
  SERVICELOOKUPS_NEW: 'servicelookups:new',
  SERVICELOOKUPFORM: 'servicelookupform',
};

export const DefaultsModel = {};
